import { render } from "./OptionsUpdated.vue?vue&type=template&id=095f27e7"
import script from "./OptionsUpdated.vue?vue&type=script&lang=js"
export * from "./OptionsUpdated.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__